module.exports = {
    panel: "panel panel-default clearfix",
    panelTitle: 'panel-title clearfix',
    panelHeading: 'panel-heading',
    panelBody: "panel-body",
    group: "form-group",
    inline: "clearfix"
};


/** WEBPACK FOOTER **
 ** ./~/subschema/src/styles/CollectionCreateTemplate-style.js
 **/